import ThemedModal from "#/components/shared/ThemedModal";
import { ActionButton } from "#/components/shared/buttons/ActionButtons";
import Textarea from "#/components/shared/textarea";
import type { ReviewCard } from "./reviewTypes";

export type ReviewEditModalProps = {
  isOpen: boolean;
  card: ReviewCard | null;
  draft: string;
  onChange: (value: string) => void;
  onCancel: () => void;
  onSave: () => Promise<void> | void;
};

export function ReviewEditModal({
  isOpen,
  card,
  draft,
  onChange,
  onCancel,
  onSave,
}: ReviewEditModalProps) {
  return (
    <ThemedModal
      isOpen={isOpen}
      onClose={onCancel}
      title="Edit review notes"
      description={card ? `Review ${card.id}` : undefined}
      tone="neutral"
      footer={
        <>
          <ActionButton
            tone="secondary"
            onClick={onCancel}
            disabled={Boolean(card?.isUpdating)}
          >
            Cancel
          </ActionButton>
          <ActionButton
            isLoading={Boolean(card?.isUpdating)}
            onClick={onSave}
          >
            Save notes
          </ActionButton>
        </>
      }
    >
      <Textarea
        id="review-notes-edit"
        label="Review notes"
        value={draft}
        onChange={(event) => onChange(event.target.value)}
        rows={8}
        fullWidth
        inputClassName="border-0 bg-cream-50 shadow-none hover:border-0 focus:border-0"
        labelClassName="text-brown-700"
      />
    </ThemedModal>
  );
}

export default ReviewEditModal;
